<!--
 * @Author: zyf
 * @Date: 2025-05-29 10:48:17
 * @LastEditors: zyf
 * @LastEditTime: 2025-06-16 20:12:12
 * @Descripttion: 
-->
<template>
  <el-popover ref="tooltipRef"  v-model="visiblePopover" @show="onOpenNotice" @before-enter="beforeEnter" popper-class="custom-popper-notify-action" :width="360" :show-arrow="false" background="#fff" placement="bottom-end" trigger="click">
    <template #reference>
      <div class="notice-badge">
        <el-badge is-dot :hidden="hasNewNotice ? false : true" class="badge">
          <slot name="customIcon">
            <i class="iconfont iconsaidi-xiaoxi notice-icon"></i>
          </slot>
        </el-badge>
      </div>
    </template>
    <div class="message-notice-container" v-loading="noticeLoading"> 
      <div class="message-notice-header">
        <div class="read-box" :class="{'is-read-list': isViewRead}" @click="onViewRead(isViewRead ? false :true)">
          只看未读
        </div>
        <div class="btn-box" @click="onClose">
          <i class="iconfont iconbimgis_guanbi close-icon"></i>
        </div>
      </div>
      <div  class="message-notice-list">
        <NoticeList v-if="!noticeLoading && noticeList?.length" :messageList="noticeList" :loading="loading" @on-notice="onNotice" @scroll="handleScroll" />
        <div v-if="!noticeLoading && noticeList?.length === 0" class="empty-box">
          <el-empty size="small" :description="isViewRead ? '暂无未读消息' : '暂未收到通知'"></el-empty>
        </div>
      </div>
      <div class="message-notice-bottom">
        <!-- <div v-if="noticeList.length" class="action" @click="onAllRead">全部已读</div> -->
        <div class="action" @click="jumpToNOtice">查看全部</div>
      </div>
    </div>
    <NoticeCenter v-if="showNoticeCenter" :show="showNoticeCenter" @refresh="getAllNotRead()" @close="showNoticeCenter = false" />
    <NoticeDetail v-if="showNoticeDetail" :show="showNoticeDetail" :noticeInfo="noticeInfo" @close="showNoticeDetail = false"/>
  </el-popover>
</template>
<script>
import {Popover,Button,Empty,Badge} from "element-ui";
import NoticeList from './components/NoticeList.vue';
import NoticeCenter from './components/NoticeCenter.vue';
import NoticeDetail from './components/NoticeDetail.vue';
import {dataInterface,getInterface} from "@/apis/data";
import { Centrifuge } from 'centrifuge';
import { getToken } from '@/utils/tools';
import { getNotRead } from './api/index';

export default {
  components: {
    "el-badge": Badge,
    "el-empty": Empty,
    "el-popover": Popover,
    "el-button": Button,
    NoticeList,
    NoticeCenter,
    NoticeDetail,
  },
  props: {

  },
  data() {
    return {
      isViewRead: false,
      noticeList: [],
      noticeLoading: true,
      showNoticeCenter: false,
      showNoticeDetail: false,
      noticeInfo: {},
      hasNewNotice: false,
      visiblePopover: false,
      loading: false,
      noMoreData: false,
      userInfo: {},
      size: 15,
      page: 1,
      total: 0,
    };
  },
  computed: {
  },
  watch: {
  },
  methods:{
    getNoticeList(isReset = true){
      this.loading = true;
      let params = {
        object_uuid: 'object6735a9889cc38',
        __method_name__: 'dataList',
        view_uuid: 'view6736c498a1746',
        transcode: 0,
        size: this.size,
        page: this.page,
      };
      if(this.isViewRead){
        params.view_uuid = 'view683e6c7d5d62a';
      }
      dataInterface(params).then((res) => {
        if(res.data.code === 200){
          const newData = res?.data?.data?.data || [];
          this.total = res?.data?.data?.total;
          if (newData.length === 0) {
            if(isReset){
              this.noticeList = newData;
            }else{
              this.noMoreData = true;
              this.page = this.page - 1;
            }
            this.loading = false;
            this.noticeLoading = false;
            return;
          }
          if(isReset){
            this.noticeList = newData;
          }else{
            this.noticeList = [...this.noticeList, ...newData];
          }
        }
        this.$nextTick(() => {
          this.loading = false;
        });
        this.noticeLoading = false;
      });
    },

    async getAllNotRead (){
      try {
        const arr = await getNotRead(this.userInfo);
        if (arr.length === 0) {
          this.hasNewNotice = false;
        } else {
          this.hasNewNotice = true;
        }
      } catch (error) {
        this.hasNewNotice = true;
      }
    },

    handleScroll() {
      if (this.page * this.size < this.total) {
        this.page++;
        this.getNoticeList(false);
      }
    },

    onViewRead(val){
      this.isViewRead = val;
      this.noticeLoading = true;
      this.noticeList = [];
      this.page = 1;
      this.getNoticeList();
    },

    beforeEnter(){
      this.noticeLoading = true;
      this.isViewRead = false;
      this.noticeList = [];
      this.page = 1;
    },

    onOpenNotice(){
      this.page = 1;
      this.noticeList = [];
      this.getNoticeList();
    },

    checkRead(data){
      const params = {
        object_uuid: 'object6735a9889cc38',
        __method_name__: 'updateData',
        view_uuid: 'view6736c498a1746',
        transcode: 0,
        data_id: data.id,
        is_read: 1,
      };
      dataInterface(params).then((res) => {
        if(res.data.code === 200){
          data.is_read = 1;
          this.getAllNotRead();
        }
      });
    },

    onClose (){
      this.visiblePopover = false;
    },

    jumpToNOtice(){
      this.onClose();
      this.showNoticeCenter = true;
    },

    onNotice(data){
      this.noticeInfo = data;
      if(data?.is_read === 0){
        // 去已读
        this.checkRead(data);
      }
      this.onClose();
      this.showNoticeDetail = true;
    },

    async updateToken() {
      // Fetch your application backend.
      const res = await getInterface('api/notify/centrifugo/getToken', {}, {
        headers: {
          Authorization: 'bearer ' + getToken('dev-metadatatoken')
        }
      });
      if (res.data.code !== 200) {
        throw new Centrifuge.UnauthorizedError();
      }
      return res.data?.data;
    },

    async getSubscriptionToken (channel) {
      const res = await getInterface('api/notify/centrifugo/getSubscriptionToken', {
        channel
      }, {
        headers: {
          Authorization: 'bearer ' + getToken('dev-metadatatoken')
        }
      });
      if (res.data.code !== 200) {
        throw new Centrifuge.UnauthorizedError();
      }
      return res.data?.data;
    },

    async initWebSocketService () {
      try {
        const res = await getInterface('api/notify/centrifugo/getConfig', {}, {
          headers: {
            Authorization: 'bearer ' + getToken('dev-metadatatoken')
          }
        });
        if (res?.data?.code === 200) {
          const centrifuge = new Centrifuge(res.data?.data.ws_url, {
            token: res.data?.data.token,
            // 设置getToken可自动刷新token
            getToken: this.updateToken()
          });

          window.centrifuge = centrifuge;

          centrifuge.on('connecting', function (ctx) {
            console.log(`connecting: ${ctx.code}, ${ctx.reason}`);
          }).on('connected', function (ctx) {
            console.log(`connected over ${ctx.transport}`);
          }).on('disconnected', function (ctx) {
            console.log(`disconnected: ${ctx.code}, ${ctx.reason}`);
          }).connect();

          // 循环订阅通道,并设置自动刷新通道令牌
          res.data?.data.channels.forEach(channel => {
            const sub = centrifuge.newSubscription(channel.channel, {
              token: channel.subscription_token,
              // 设置getToken可自动刷新通道令牌
              getToken: this.getSubscriptionToken(channel.channel)
            });
            console.log(sub, 'subsub');
            sub.on('publication', function (ctx) {
              // 向一个特定频道发送消息的行为 
              // console.log('这是通道接收的相关消息', ctx.data);
              this.hasNewNotice = true;
            }).on('subscribing', function (ctx) {
              // 正在尝试订阅一个频道的过程
              console.log(`subscribing: ${ctx.code}, ${ctx.reason}`);
            }).on('subscribed', function (ctx) {
              // 已经成功订阅了一个频道，可以开始接收来自该频道的消息
              console.log('subscribed', ctx);
            }).on('unsubscribed', function (ctx) {
              // 已取消订阅
              console.log(`unsubscribed: ${ctx.code}, ${ctx.reason}`);
            }).subscribe();
          });
        }
      } catch (error) {
        console.log(error)
      }

    }
  },
  mounted() {
    this.initWebSocketService();
  },
  created() {
    this.userInfo = this.$GetUserInfo();
    this.getAllNotRead();
  },
}
</script>
<style lang="less">
.custom-popper-notify-action {
  display: flex;
  width: 360px;
  height: 400px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px !important;
  overflow: hidden;
  background: #FFF;
  border-radius: 8px;
  background: var(--overall-surface-default, #FFF);
  box-shadow: 0px 1px 3px 0px rgba(25, 27, 35, 0.04), 0px 0px 0px 0px rgba(255, 255, 255, 0.01) inset, 0px 2px 16px 0px rgba(25, 27, 35, 0.08);
  padding: 0 !important;
  box-sizing: border-box;
}
</style>
<style scoped lang='less'>
.notice-badge{
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .notice-icon{
    color: var(--icon-on-brand-primary, #FFF);
    font-size: 20px;
    display: block;
  }
  &:hover,&:active,&.is-active{
    background: rgba(255, 255, 255, 0.16);
  }
  :deep(.el-badge){
    .el-badge__content{
      width: 6px;
      height: 6px;
      top: 1px;
      right: 7px;
      border: none;
      background: var(--semantic-error-on-background, #FC5558);
    }
  }
}
.message-notice-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .message-notice-header {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
    flex-shrink: 0;
    border-bottom: 1px solid var(--border-on-surface-weak, #F0F1F4);
    .read-box{
      display: inline-flex;
      height: 24px;
      padding: 0 8px;
      box-sizing: border-box;
      justify-content: center;
      align-items: center;
      gap: var(--spacing-3, 6px);
      flex-shrink: 0;
      color: var(---button-neutral-secondary-on-background, #424751);
      font-family: "PingFang SC";
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.4px;
      border-radius: 4px;
      border: 1px solid transparent;
      &.is-read-list,&:hover{
        border-color: var(--field-border-focus-outer, #639DFF);
        color: var(--text-on-surface-brand, #387FFC);
      }
    }
    .title{
      color: var(---button-neutral-secondary-on-background, #424751);
      font-family: "PingFang SC";
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.4px;
      display: block;
      cursor: pointer;
    }
    .btn-box {
      width: 24px;
      height: 24px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover {
        background: var(--overall-surface-default-hover, #F4F6F9);
      }
      &:active {
        background: var(--brand-gray-90, #E1E4EC);
      }
      i {
        font-size: 16px;
        display: block;
        color: var(--icon-on-surface-secondary,#4D535E);
      }
    }
  }
  .message-notice-list {
    width: 100%;
    flex: 1;
    padding: 8px;
    box-sizing: border-box;
    overflow: hidden;
    .empty-box {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .message-notice-bottom {
    border-top: 1px solid var(--border-on-surface-overlay, rgba(0, 0, 0, 0.06));
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    flex-shrink: 0;
    .action {
      flex: 1;
      color: var(--text-on-surface-tertiary, #707786);
      font-family: "PingFang SC";
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.4px;
      text-align: center;
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      &:first-child{
        border-right: 1px solid #F0F1F4;
      }
    }
  }
}
</style>